<div class="footer flex">
  <div class="d-flex justify-content-center container mt-3">
    <div class="font-medium ltr:ml-4 rtl:mr-4 hidden sm:block text-primary text-center">
     &copy; WEBTEST {{date}}
    </div>
  </div>
</div>
